<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Usuarios</span>

  <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
    <ul fxLayout="row" fxLayoutGap="20px">
      <li>
        <button mat-icon-button (click)="openDialogCreateUser()">
          <mat-icon>person_add</mat-icon>
        </button>
      </li>
    </ul>
  </div>
</mat-toolbar>

<div class="margin-container apearAnimation">
  <!-- <app-tableusr></app-tableusr> -->

  <mat-toolbar>
    <mat-form-field class="example-form-field">
      <mat-label>Nombre o Número de documento</mat-label>
      <input
        matInput
        type="text"
        [(ngModel)]="searchString"
        (keyup.enter)="onEnter()"
      />
      <button
        *ngIf="searchString"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="searchString = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </mat-toolbar>

  <div class="loading-indicator" *ngIf="isLoadingResults">
    <mat-spinner></mat-spinner>
  </div>

  <mat-form-field>
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">

   
      <table mat-table [dataSource]="dataSource">
  <!--       <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>No.</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container> -->
  
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
        </ng-container>
  
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let element">{{ element.email }}</td>
        </ng-container>
  
        <ng-container matColumnDef="documento">
          <th mat-header-cell *matHeaderCellDef>Documento</th>
          <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
        </ng-container>
  
        <ng-container matColumnDef="botones">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button
              color="accent"
              mat-icon-button
              aria-label="Edit"
              (click)="edit(element)"
            >
              <mat-icon>edit</mat-icon>
            </button>
  
            <button mat-icon-button color="warn" aria-label="Delete" 
            mat-icon-button
            aria-label="Delete"
            (click)="delete(element)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>


    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</div>
